export function replaceTemplateBlocksInString(str, textBlocks) {
  if (!str || !textBlocks || !Array.isArray(textBlocks)) {
    return str;
  }

  let output = str;

  for (const { key, value } of textBlocks) {
    if (!key) continue;

    // Escape regex special chars in the key
    const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Escape $ in value to prevent special replacement patterns ($&, $', $`, etc.)
    const safeValue = (value ?? '').replace(/\$/g, '$$$$');

    output = output.replace(new RegExp(escaped, 'g'), safeValue);
  }

  return output;
}
